import React from "react";
export default function LegislationForm({ legislation, setLegislation }) {
  const updateLegislation = (idx, value) => {
    const arr = [...legislation];
    arr[idx] = value;
    setLegislation(arr);
  };
  return (
    <fieldset className="fra-fieldset">
      <legend>Relevant Legislation & Standards</legend>
      {legislation.map((l, idx) => (
        <div key={idx} style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
          <input
            type="text"
            value={l}
            onChange={e => updateLegislation(idx, e.target.value)}
            placeholder="e.g. Regulatory Reform (Fire Safety) Order 2005"
            style={{ flex: 1 }}
          />
          <button type="button" onClick={() => setLegislation(legislation.filter((_, i) => i !== idx))}>✕</button>
        </div>
      ))}
      <button type="button" onClick={() => setLegislation([...legislation, ""])} style={{ marginTop: 6 }}>
        Add Legislation/Standard
      </button>
    </fieldset>
  );
}
